<footer
  class="bg-black border border-l-0 border-b-0 border-r-0 border-t-8 border-t-[#ff4d06] relative"
>
  <small class="absolute top-1 right-1 text-gray-600 font-mono"
    ><i>V{{ ver }}</i>
  </small>
  <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
    <div class="md:flex flex-col gap-4 md:justify-between">
      <app-logoc></app-logoc>
      <!-- <div class="flex justify-center">
        <a href="https://www.vote.bestweb.lk/site/softnetcomputers_lk"
          ><img
            src="https://www.bw2024.lk/vote4us.png"
            alt="logo"
            width="150"
            height="150"
        /></a>
      </div> -->

      <div class="grid grid-cols-2 md:grid-cols-4 w-full gap-4 mt-4">
        <a
          href="https://www.softnetcomputers.lk/"
          target="_self"
          class="text-wrap text-gray-500 pt-1 text-center"
          >HOME</a
        >
        <a
          routerLink="/about-us"
          class="text-wrap text-gray-500 pt-1 text-center"
          >ABOUT US</a
        >
        <a
          routerLink="/payment-details"
          class="text-wrap text-gray-500 pt-1 text-center"
          >PAYMENT DETAILS</a
        >
        <a
          routerLink="/contact-us"
          class="text-wrap text-gray-500 pt-1 text-center"
          >CONTACT US</a
        >
      </div>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
    <div class="mb-6 md:mb-0 flex flex-row items-center gap-2 w-full">
      <div
        class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3 content-evenly justify-between w-full"
      >
        <div *ngFor="let catChunk of cats; let i = index" class="w-full">
          <h2 class="mb-6 text-sm font-semibold text-white uppercase">
            <span *ngIf="i === 0">Categories</span>
            <span *ngIf="i !== 0">&nbsp;&nbsp;&nbsp;</span>
          </h2>
          <ul class="text-gray-500 dark:text-gray-400 font-medium">
            <li class="mb-4" *ngFor="let item of catChunk">
              <a [routerLink]="['/', item.slug]" class="text-wrap w-full">{{
                item.label | uppercase
              }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mb-6 md:mb-0 flex flex-row items-center gap-2 w-full">
      <div
        class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3 content-evenly justify-between w-full"
      >
        <div>
          <h2 class="mb-6 text-sm font-semibold text-white uppercase">
            <span>Legal</span>
          </h2>
          <ul class="text-gray-500 dark:text-gray-400 font-medium">
            <li class="mb-4">
              <a routerLink="/privacy-policy" class="text-wrap">
                PRIVACY POLICY</a
              >
            </li>

            <li class="mb-4">
              <a routerLink="/cookie-policy" class="text-wrap"
                >COOKIE POLICY
              </a>
            </li>

            <li class="mb-4">
              <a routerLink="/terms-and-conditions" class="text-wrap"
                >TERMS AND CONDITIONS
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h2 class="mb-6 text-sm font-semibold text-white uppercase">
            <span>HELP</span>
          </h2>
          <ul class="text-gray-500 dark:text-gray-400 font-medium">
            <li class="mb-4">
              <a
                routerLink="/help/how-to-use-filters"
                class="text-wrap uppercase"
              >
                How to use filters ?</a
              >
            </li>

            <li class="mb-4">
              <a
                routerLink="/help/quotation-generation"
                class="text-wrap uppercase"
                >How to use quotation generation ?</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
    <div class="sm:flex sm:items-center sm:justify-between">
      <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400"
        >© 2024 <a href="https://flowbite.com/" class="">Softnet Computers</a>.
        All Rights Reserved.
      </span>
      <div class="flex mt-4 sm:justify-center sm:mt-0 gap-4">
        <a
          target="_blank"
          href="https://www.tiktok.com/@softnetcomputers?_t=8lI15zNGKe0&_r=1"
          aria-label="tik tok account"
          class="text-gray-500 px-2"
        >
          <svg
            fill="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            class="w-5 h-5"
            viewBox="0 0 24 24"
          >
            <path
              d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.104,4,24,4z M22.689,13.474 c-0.13,0.012-0.261,0.02-0.393,0.02c-1.495,0-2.809-0.768-3.574-1.931c0,3.049,0,6.519,0,6.577c0,2.685-2.177,4.861-4.861,4.861 C11.177,23,9,20.823,9,18.139c0-2.685,2.177-4.861,4.861-4.861c0.102,0,0.201,0.009,0.3,0.015v2.396c-0.1-0.012-0.197-0.03-0.3-0.03 c-1.37,0-2.481,1.111-2.481,2.481s1.11,2.481,2.481,2.481c1.371,0,2.581-1.08,2.581-2.45c0-0.055,0.024-11.17,0.024-11.17h2.289 c0.215,2.047,1.868,3.663,3.934,3.811V13.474z"
            />
          </svg>
        </a>

        <a
          target="_blank"
          href="https://fb.com/softnetcomputers.lk"
          class="text-gray-500"
          aria-label="facebook account"
        >
          <svg
            fill="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            class="w-5 h-5"
            viewBox="0 0 24 24"
          >
            <path
              d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"
            ></path>
          </svg>
        </a>

        <a
          target="_blank"
          href="https://www.instagram.com/softnet_technics"
          aria-label="insta account"
          class="ml-3 text-gray-500"
        >
          <svg
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            class="w-5 h-5"
            viewBox="0 0 24 24"
          >
            <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
            <path
              d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"
            ></path>
          </svg>
        </a>

        <a
          class="ml-3 text-gray-500"
          target="_blank"
          href="https://api.whatsapp.com/send/?phone=%2B94772553478&text&app_absent=0"
          aria-label="whatsapp account"
        >
          <svg
            fill="currentColor"
            stroke="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="5"
            class="w-5 h-5"
            viewBox="0 0 24 24"
          >
            <path
              d="m12 1.9673c-5.5406 0-10.033 4.4922-10.033 10.033 0 1.8821 0.52868 3.6369 1.4304 5.1421l-1.3406 4.8906 4.9951-1.3112c1.4609 0.83056 3.1473 1.3112 4.9478 1.3112 5.5406 0 10.033-4.4922 10.033-10.033 0-5.5406-4.4922-10.033-10.033-10.033zm-3.4341 5.3527c0.16303 0 0.33054-9.954e-4 0.47518 0.00658 0.17892 0.00424 0.37365 0.017279 0.56009 0.42946 0.22156 0.48993 0.70398 1.719 0.76584 1.8436 0.06187 0.12457 0.10571 0.27133 0.01959 0.43436-0.08193 0.16721-0.12455 0.26841-0.24494 0.4164-0.12457 0.1438-0.26107 0.3224-0.37394 0.43109-0.12457 0.12457-0.25321 0.26116-0.1094 0.50948 0.1438 0.24831 0.64322 1.0623 1.3815 1.7195 0.94893 0.84777 1.7496 1.1083 1.9987 1.2329 0.24915 0.12457 0.39343 0.10517 0.53724-0.06206 0.14798-0.16303 0.62149-0.72245 0.7887-0.9716 0.16303-0.24914 0.32946-0.20604 0.5552-0.1241 0.22908 0.08193 1.4507 0.68373 1.6999 0.8083 0.24915 0.12457 0.41248 0.18623 0.47518 0.2874 0.06438 0.1045 0.06444 0.60202-0.14207 1.1822-0.20651 0.57939-1.2206 1.1397-1.6754 1.179-0.459 0.04264-0.88736 0.20631-2.9834-0.61888-2.5282-0.99575-4.1227-3.5853-4.2472-3.7525-0.12457-0.16303-1.0124-1.3463-1.0124-2.567 0-1.2248 0.64219-1.8247 0.86709-2.0738 0.22908-0.24915 0.49739-0.31026 0.6646-0.31026z"
              stroke-width=".83606"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
  <div
    class="w-full bg-[#ff4d06] text-center text-white py-2 text-md flex flex-row justify-center items-center"
  >
    <span> Designed and developed by &nbsp;</span>
    <a
      [ariaLabel]="'HeavensCode best in negombo, 077 4028857'"
      class="!text-white !text-md"
      target="_blank"
      href="www.theheavenscode.com"
      ><u> Heaven'sCode</u></a
    >
  </div>
</footer>
